import { render, staticRenderFns } from "./BottomNav.vue?vue&type=template&id=d69a53ba&scoped=true"
var script = {}
import style0 from "./BottomNav.vue?vue&type=style&index=0&id=d69a53ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d69a53ba",
  null
  
)

export default component.exports